import { z } from "zod"

export const powurOsWarrantyPricing = z.object({
  name: z.string(),
  cost: z.number(),
  id: z.number(),
  eligible: z.boolean(),
  family: z.string(),
  localizedName: z.string(),
})

export type PowurOsWarrantyPricing = z.infer<typeof powurOsWarrantyPricing>

export const getWarrantyPricingResponseSchema = z.object({
  model: z.array(powurOsWarrantyPricing),
})

export type GetWarrantyPricingResponse = z.infer<
  typeof getWarrantyPricingResponseSchema
>
